import {
  Button,
  Typography,
} from "@mui/material";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import { useCommonDateFormats } from "../../../services/hooks/index.js";
import { MessageDialog } from "../../message/index.js";
import GenericNotificationItem from "./_generic-notification-item.js";
import getUserName from "./_get-user-name.js";

export default memo(({ notif }) => {
  const { t } = useTranslation();
  const { formatDayAndMonth } = useCommonDateFormats();
  const actions = {};

  return (
    <GenericNotificationItem notif={notif} title={t("new_message_in", { plan: notif.metadata.planName })}>
      <Typography
        sx={{
          marginBottom: "5px", whiteSpace: "pre-line", width: "100%", wordBreak: "break-word",
        }}
        component="span"
        variant="body2"
        color="text.primary"
      >
        {notif.metadata.entryTitle}
        {" "}
        (
        {formatDayAndMonth(notif.metadata.entryDate)}
        )
        {" — "}
        <i>{notif.metadata.content}</i>
      </Typography>
      <Button
        variant="outlined"
        size="small"
        sx={{ marginTop: "10px", marginBottom: "10px" }}
        onClick={() => {
          actions.open(notif.metadata.entryId, notif.metadata.subordinateId, getUserName(notif));
        }}
      >
        {t("reply")}
      </Button>
      <MessageDialog actions={actions} />
    </GenericNotificationItem>
  );
});
